/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CommonGuideDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class CommonGuideService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags CommonGuideService
   * @name GetAllGuides
   * @summary Get All Guides
   * @request GET:/v1/guides
   * @secure
   */
  getAllGuides = (
    query: {
      locale: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CommonGuideDto[], any>({
      path: `/v1/guides`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
